<template>
  <div>
    <v-form ref="candidateForm" lazy-validation>
      <div v-if="sm">
        <v-row no-gutters>
          <v-col cols="12">
            <v-btn
              color="primary"
              class="sm-toggle-button sm-toggle-button-left"
              :outlined="newCandidateOutlined"
              @click="newCandidateClickedHandler"
            >
              New Candidate
            </v-btn>
            <v-btn
              class="sm-toggle-button sm-toggle-button-right"
              color="primary"
              :outlined="existingCandidateOutlined"
              @click="existingCandidateClickedHandler"
            >
              Existing Candidate
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3" v-if="isExistingCandidate">
            <UsersDropDownList
              :userId="existingUserId"
              :isRequired="isExistingCandidate"
              :readonly="readonly"
              label="Consultant"
              :securityRoles="[CONSULTANT]"
              @userIdChange="userIdChangeHandler"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              label="First Name"
              v-model="firstName"
              :rules="[Required('First Name')]"
              :readonly="isExistingCandidate || readonly"
              :disabled="noClientOptionSelected"
              outlined
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-text-field
              label="Last Name"
              v-model="lastName"
              :rules="[Required('Last Name')]"
              :readonly="isExistingCandidate || readonly"
              :disabled="noClientOptionSelected"
              outlined
            />
          </v-col>

          <v-col cols="12" md="3">
            <EmailInput
              label="Login E-Mail"
              :email-address="emailAddress"
              :is-required="true"
              :readOnly="isExistingCandidate || readonly"
              :disabled="noClientOptionSelected"
              @emailChange="emailAddress = $event"
            />
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row>
          <v-col cols="12" sm="6">
            <v-btn
              block
              min-height="200px"
              color="primary"
              style="font-size: 30px"
              :outlined="newCandidateOutlined"
              @click="newCandidateClickedHandler"
            >
              New<br>Candidate
            </v-btn>
          </v-col>

          <v-col cols="12" sm="6">
            <v-btn
              block
              min-height="200px"
              color="primary"
              style="font-size: 30px"
              :outlined="existingCandidateOutlined"
              @click="existingCandidateClickedHandler"
            >
              Existing<br>Candidate
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="3" v-if="isExistingCandidate">
            <UsersDropDownList
              :userId="existingUserId"
              :isRequired="isExistingCandidate"
              :readonly="readonly"
              label="Consultant"
              :securityRoles="[CONSULTANT]"
              @userIdChange="userIdChangeHandler"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              label="First Name"
              v-model="firstName"
              :rules="[Required('First Name')]"
              :readonly="isExistingCandidate || readonly"
              :disabled="noClientOptionSelected"
              outlined
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-text-field
              label="Last Name"
              v-model="lastName"
              :rules="[Required('Last Name')]"
              :readonly="isExistingCandidate || readonly"
              :disabled="noClientOptionSelected"
              outlined
            />
          </v-col>

          <v-col cols="12" md="3">
            <EmailInput
              label="Login E-Mail"
              :email-address="emailAddress"
              :is-required="true"
              :readOnly="isExistingCandidate || readonly"
              :disabled="noClientOptionSelected"
              @emailChange="emailAddress = $event"
            />
          </v-col>
        </v-row>
      </div>
    </v-form>
  </div>
</template>

<script>
import { UsersDropDownList } from '@/components/users'
import Required from '@/lib/formValidations/required'
import { EmailInput } from '@/components/emails'
import { NEW_CANDIDATE, EXISTING_CANDIDATE } from '@/lib/constants/candidateTypes'
import { CONSULTANT } from '@/lib/constants/securityRoles'

export default {
  name: 'DealSingleCandidate',

  props: [
    'candidate',
    'readonly',
    'sm'
  ],

  components: {
    UsersDropDownList,
    EmailInput
  },

  data () {
    return {
      NEW_CANDIDATE: NEW_CANDIDATE,
      EXISTING_CANDIDATE: EXISTING_CANDIDATE,
      CONSULTANT: CONSULTANT
    }
  },

  computed: {
    newCandidateOutlined () {
      return !this.isNewCandidate ||
      (!!this.candidate.candidateTypeId && this.candidate.candidateTypeId !== this.NEW_CANDIDATE)
    },

    existingCandidateOutlined () {
      return !(
        this.candidate.candidateTypeId === this.EXISTING_CANDIDATE ||
        this.candidate.existingUserId
      )
    },

    noClientOptionSelected () {
      return this.newCandidateOutlined && this.existingCandidateOutlined
    },

    candidateId () {
      return this.candidate && this.candidate.id
    },

    isExistingCandidate () {
      return this.candidate &&
        (this.candidate.candidateTypeId === this.EXISTING_CANDIDATE ||
        !!this.candidate.existingUserId)
    },

    isNewCandidate () {
      return (!this.candidate.existingUserId &&
        (!!this.candidate.firstName ||
        !!this.candidate.lastName ||
        !!this.candidate.emailAddress
        )) ||
        this.candidate.candidateTypeId === this.NEW_CANDIDATE
    },

    candidateTypeId: {
      get () {
        return this.candidate
          ? this.candidate.candidateTypeId
          : null
      },
      set (value) {
        this.$emit('setCandidateTypeId', this.candidateId, value)
      }
    },

    existingUserId: {
      get () {
        return this.candidate
          ? this.candidate.existingUserId
          : null
      },
      set (value) {
        this.$emit('setExistingCandidateId', this.candidateId, value)
      }
    },

    firstName: {
      get () {
        return this.candidate
          ? this.candidate.firstName
          : ''
      },
      set (value) {
        this.$emit('setFirstName', this.candidateId, value)
      }
    },

    lastName: {
      get () {
        return this.candidate
          ? this.candidate.lastName
          : ''
      },
      set (value) {
        this.$emit('setLastName', this.candidateId, value)
      }
    },

    emailAddress: {
      get () {
        return this.candidate
          ? this.candidate.emailAddress
          : ''
      },
      set (value) {
        this.$emit('setEmailAddress', this.candidateId, value)
      }
    }
  },

  methods: {
    Required: Required,

    newCandidateClickedHandler () {
      if (!this.readonly) {
        this.resetFormValidation()
        this.$emit('setCandidateTypeId', this.candidateId, this.NEW_CANDIDATE)
      }
    },

    existingCandidateClickedHandler () {
      if (!this.readonly) {
        this.resetFormValidation()
        this.$emit('setCandidateTypeId', this.candidateId, this.EXISTING_CANDIDATE)
      }
    },

    userIdChangeHandler (newUserId) {
      this.resetFormValidation()
      this.$emit('setExistingCandidateId', this.candidateId, newUserId)
    },

    resetFormValidation () {
      if (this.$refs.candidateForm) {
        this.$refs.candidateForm.resetValidation()
      }
    },
    isCandidateValid () {
      return this.$refs.candidateForm.validate() ? true : 'Please fill out the required fields to proceed'
    }
  },

  mounted () {
    this.resetFormValidation()
  }
}
</script>
<style>
.sm-toggle-button {
  min-height:55px !important;
  width: 50% !important;
}

.sm-toggle-button-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.sm-toggle-button-left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
